import { useState } from "react";
import { Button as MuiButton, Menu, type SxProps } from "@mui/material";
import { type ButtonVariantOption } from "../Button/Button";

export enum ColorOption {
  Inherit = "inherit",
  Primary = "primary",
  Secondary = "secondary",
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
  Brand = "brand",
}

interface IProps {
  label: string;
  children: React.ReactNode;
  buttonColor?: ColorOption;
  endIcon?: React.ReactNode;
  variant?: ButtonVariantOption;
  disabled?: boolean;
  sx?: SxProps;
}

const ButtonMenu: React.FC<IProps> = (props) => {
  const {
    label,
    children,
    buttonColor = ColorOption.Inherit,
    variant,
    disabled,
    endIcon,
    sx,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <MuiButton
        id="basic-button"
        aria-controls={isOpen ? "button-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        onClick={handleClick}
        color={buttonColor}
        endIcon={endIcon}
        variant={variant}
        disabled={disabled}
        sx={sx}
      >
        {label}
      </MuiButton>
      <Menu
        id="button-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div onClick={handleClose}>{children}</div>
      </Menu>
    </>
  );
};

export { ButtonMenu };
